import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { PlayerSearchDialogComponent } from 'src/app/player-search-dialog/player-search-dialog.component';
import { PlayerViewModel } from '../../models/player.model';
import { PlayerService } from '../../player.service';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListOption, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-select-single-player-dialog',
    templateUrl: './select-single-player-dialog.component.html',
  standalone: true,
    styleUrls: ['./select-single-player-dialog.component.css'],
    imports: [MatDialogTitle, ReactiveFormsModule, MatFormField, MatInput, MatButton, CdkScrollable, MatDialogContent, MatSelectionList, FormsModule, NgFor, MatListOption, MatListItemTitle, MatListItemLine, MatDialogActions, MatDialogClose, DatePipe]
})
export class SelectSinglePlayerDialogComponent implements OnInit {

  @Output() dataChanged =  new EventEmitter();
  @Input() Action: string;

  playersForm: UntypedFormGroup;
  isLoading = false;
  filteredPlayers: PlayerViewModel[] = [];
  positionNames =  ['','G','D','D','F','F','F'];
  selectedPlayer: string;

  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<PlayerSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _playerService: PlayerService
  ) { }

 

  ngOnInit() {

    this.playersForm = this.fb.group({
      userInput: null
    })

    

  }


  search(){
    this._playerService.search(this.playersForm.get('userInput').value).subscribe((results: PlayerViewModel[])=>{
      this.filteredPlayers = results;
    });

  }

}
